<template>
  <div>
    <div>
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <div class="dropbox">
          <p v-if="isInitial">
            {{ title }}
          </p>
          <p v-if="isSaving">
            در حال آپلود
          </p>
          <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                 accept="image/*" class="input-file">
        </div>
      </form>
      <!--SUCCESS-->
      <div v-if="isSuccess">
        <h2>Uploaded {{ uploadedFiles.length }} file(s) successfully.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Upload again</a>
        </p>
        <ul class="list-unstyled">
          <li v-for="item in uploadedFiles" :key="item">
            <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
          </li>
        </ul>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2>آپلود با خطا مواجه شد</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">تلاش مجدد</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
export default {
  name: 'app',
  props: ['title', 'saveUrl'],
  data () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'image'
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    upload (formData) {
      const url = `${this.saveUrl}`
      return axios.post(url, formData)
      // get data
        .then(x => x.data)
        // add url field
        .then(x => x.map(img => Object.assign({},
          img, {url: `${this.saveUrl}/images/${img.id}`})))
    },
    wait (ms) {
      return (x) => {
        return new Promise(resolve => setTimeout(() => resolve(x), ms))
      }
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      this.upload(formData)
        .then(x => {
          // this.uploadedFiles = [].concat(x)
          this.currentStatus = STATUS_SUCCESS
        })
        .catch(err => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()
      if (!fileList.length) return
      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })
      // save it
      this.save(formData)
    }
  },
  mounted () {
    this.reset()
  }
}
</script>

<style scoped>
.dropbox {
  /*outline: 2px dashed grey; !* the dash box *!*/
  /*outline-offset: -10px;*/
  background: lightcyan;
  color: dimgray;
  padding: 5px;
  /*cursor: pointer;*/
}

.input-file {
  opacity: 1; /* invisible but it's there! */
  /*cursor: pointer;*/
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue